export const ALL_SECTION_NAME = 'All';
export const ARCHIVE_SECTION_NAME = 'Archive';
export const TRASH_SECTION_NAME = 'Trash';
